import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Switch } from "@/components/ui/switch";

const EMPTY = { name: "", url: "", stream_type: "rtsp", location: "", order: 0, enabled: true };
const TYPES = [
  { v: "rtsp", label: "RTSP (convertido pelo servidor)", ph: "rtsp://usuario:senha@ip:554/stream" },
  { v: "hls", label: "HLS (.m3u8)", ph: "https://servidor/camera/index.m3u8" },
  { v: "mjpeg", label: "MJPEG (link direto)", ph: "https://ip/video.mjpg" },
];

export const CameraForm = ({ open, initial, onClose, onSave, saving }) => {
  const [f, setF] = useState(EMPTY);
  useEffect(() => { if (open) setF(initial ? { ...EMPTY, ...initial } : EMPTY); }, [open, initial]);
  const set = (k) => (e) => setF({ ...f, [k]: e?.target ? e.target.value : e });
  const type = TYPES.find((t) => t.v === f.stream_type);

  const submit = (e) => {
    e.preventDefault();
    onSave({ ...f, name: f.name.trim(), url: f.url.trim(), order: Number(f.order) || 0 });
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="vl-dialog" data-testid="camera-form-dialog">
        <DialogHeader><DialogTitle className="title-sm">{initial ? "Editar câmera" : "Nova câmera"}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <label className="field"><span>Nome da câmera</span>
            <input value={f.name} onChange={set("name")} required maxLength={80} data-testid="camera-name-input" /></label>
          <label className="field"><span>Tipo de link</span>
            <select value={f.stream_type} onChange={set("stream_type")} data-testid="camera-type-select">
              {TYPES.map((t) => <option key={t.v} value={t.v}>{t.label}</option>)}
            </select></label>
          <label className="field"><span>Link do stream</span>
            <input value={f.url} onChange={set("url")} required placeholder={type.ph} className="mono"
              data-testid="camera-url-input" /></label>
          <div className="grid grid-cols-3 gap-3">
            <label className="field col-span-2"><span>Local (opcional)</span>
              <input value={f.location} onChange={set("location")} data-testid="camera-location-input" /></label>
            <label className="field"><span>Ordem</span>
              <input type="number" value={f.order} onChange={set("order")} data-testid="camera-order-input" /></label>
          </div>
          <div className="flex items-center justify-between field-row">
            <span>Exibir na página inicial</span>
            <Switch checked={f.enabled} onCheckedChange={set("enabled")} data-testid="camera-enabled-switch" />
          </div>
          <div className="flex gap-3 justify-end pt-2">
            <button type="button" className="btn-ghost" onClick={onClose} data-testid="camera-form-cancel">Cancelar</button>
            <button className="btn-primary" disabled={saving} data-testid="camera-form-submit">
              {saving ? "Salvando..." : "Salvar"}</button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
